import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import NutritionSection from './components/NutritionSection';
import ProductsSection from './components/ProductsSection';
import PurchaseSection from './components/PurchaseSection';
import Footer from './components/Footer';
import HomeJsonLd from '@/components/seo/HomeJsonLd';
import HomeSeo from '@/components/seo/HomeSeo';

const HomePage = () => (
  <div className="min-h-screen font-sans">
    <HomeSeo />
    <HomeJsonLd />
    <Navbar />
    <HeroSection />
    <AboutSection />
    <NutritionSection />
    <ProductsSection />
    <PurchaseSection />
    <Footer />
  </div>
);

export default HomePage;
